import { render, staticRenderFns } from "./ApplicantKnownLanguagesQuestion.vue?vue&type=template&id=124b69bd"
import script from "./ApplicantKnownLanguagesQuestion.vue?vue&type=script&lang=js"
export * from "./ApplicantKnownLanguagesQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports